import { RouteDeductionDetailsReportTable, TableContentWithoutEditDateFromat } from '../../../Common/Table/tableContent';
import React from "react";
import tokenService from '../../../../Common/tokenDecoder';

export default class ComponentToPrint extends React.Component {
    render() {

        const data = this.props.data;
        const rowNames = this.props.rowNames;
        const searchData = this.props.searchData;
        const totalRow = this.props.totalRow;
        const columeNames = this.props.columeNames;
        const inishialColumName = [{
            title: 'Date', field: 'weightReadTime', render: rowData => rowData.weightReadTime, headerStyle: {
                color: '#000000',
                textAlign: 'center',
                fontWeight: 'bold'
            }, cellStyle: { textAlign: 'left' }

        }]

        return (
            <div>
                <h3><center><u>Route Deduction Details Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.estate}</div>
                    <div className="col"><b>From Date: </b> {searchData.fromDate}</div>
                    <div className="col"><b>To Date: </b> {searchData.toDate}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                    <div className="col"><b>Date/Time: </b> {new Date().toLocaleString()}</div>
                </div>
                <table id="totalCropPdf">
                    <thead>
                        <tr>
                            {rowNames.map((x, index) => {
                                let result = x.replace(/([A-Z])/g, " $1");
                                let finalResult = result.charAt(0).toUpperCase() + result.slice(1);
                                if (finalResult === "Collection Point Name") {
                                    finalResult = "Route Name";
                                }
                                else if (finalResult === "Collection Point Code") {
                                    finalResult = "RC";
                                }
                                else if (finalResult === "Collection Type Name") {
                                    finalResult = "LT";
                                }
                                else if (finalResult === "Number Of Units") {
                                    finalResult = "BC";
                                }
                                else if (finalResult === "Gross Amount") {
                                    finalResult = "Gross / kg";
                                }
                                else if (finalResult === "Total") {
                                    finalResult = "TotDeduc";
                                }
                                return (
                                    <th key={index}>{finalResult}</th>
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        <RouteDeductionDetailsReportTable
                            data={data}
                            contentRowNames={rowNames}
                            hasEdit={false}
                        />
                    </tbody>
                </table>
                <hr />
            </div>
        );
    }
}